// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iWkG","col":"styles_col__YW0k3"};